module.exports = __webpack_public_path__ + "static/img/icon_article_ default.64f80697.png";